module.exports = __webpack_public_path__ + "img/LiBeirut-D.9fd3b6d1.jpeg";